import {FullScreenClicker} from "@nolimitcity/slot-game/bin/core/component/FullScreenClicker";
import {DirtyWildsLayerConfig} from "../../config/DirtyWildsLayerConfig";
import {WinCountUpDisplay} from "./WinCountUpDisplay";
import {DirtyWildsParsedGameData} from "../server/data/DirtyWildsParsedGameData";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {DirtyWilds} from "../DirtyWilds";
import {TimelineLite} from "gsap";
import {DirtyWildsGameConfig, IDirtyWildWinRatioConfig} from "../DirtyWildsGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {DirtyWildsGameAssets} from "../DirtyWildsGameAssets";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {DirtyWildsSoundConfig} from "../DirtyWildsSoundConfig";
import {DirtyWildsSpineAnimationNames} from "../../config/DirtyWildsSpineAnimationNames";
import {DirtyWildGameModuleConfig} from "../DirtyWildGameModuleConfig";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

/**
 * Created by Jonas Wålekvist on 2018-10-15.
 */
export class WinCountUpPresentationView extends FullScreenClicker {

    set abortFunction(value:Function) {
        this._abortFunction = value;
    }

    private _countUp:WinCountUpDisplay;
    private _winRatioConfig:IDirtyWildWinRatioConfig;
    private _winRatioType:WinRatioType;
    private _bigWinSpine:PIXI.spine.Spine;
    private _isPotrait:boolean;
    private _abortFunction:Function;

    constructor() {
        super(() => this.onClick(), DirtyWildsLayerConfig.WIN_DISPLAY.name);
        this._layer.addChild(this);
    }


    protected initAnimations():void {
        super.initAnimations();
        var _this = this;
        this._bigWinSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.BIG_WIN_SPINE));
        this.addChild(this._bigWinSpine);
        this._bigWinSpine.position.set(360, 310);
        this._countUp = new WinCountUpDisplay();
        this.addChild(this._countUp);
        this.spineInit();

    }

    private spineInit():void{
        this._bigWinSpine.stateData.setMix("step1Start", "step1", 0.1);
        this._bigWinSpine.stateData.setMix("step1", "step2Start", 0.1);
        this._bigWinSpine.stateData.setMix("step2Start", "step2", 0.1);
        this._bigWinSpine.stateData.setMix("step2", "step3Start", 0.1);
        this._bigWinSpine.stateData.setMix("step3Start", "step3", 0.1);
    }

    private onClick() {
        this.enabled = false;
        if(this._abortFunction) {
            this._abortFunction();
        }
    }


    public getCountUp(symbolDuration:number, gameData:DirtyWildsParsedGameData):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        this._winRatioConfig = gameData.currentMultipliedWinRatioConfig!;
        this._winRatioType = this._winRatioConfig.type!;

        //this._isBigWin = gameData.currentMultipliedWinRatio >= DirtyWildsGameConfig.instance.WIN_RATIOS.bigWin[0].ratio;


        tl.add(() => this.enabled = true);

        if(gameData.isMultipliedBigWin) {
            tl.add(this.createBigWin(symbolDuration, gameData));
        }
        symbolDuration = (gameData.totalSpinWinningsMultiplied != gameData.singleWin && gameData.currentWinRatio <= 2)?  0.4 : this._winRatioConfig.duration;
        tl.add(this.createCountUp(symbolDuration, gameData), 0);
        tl.add(() => this.enabled = false);

        return tl;
    }

    public getEndAnimation(gameData:DirtyWildsParsedGameData):TimelineLite {
        this.enabled = false;
        const tl:TimelineLite = new TimelineLite();
        const multipliedWin:number = gameData.totalSpinWinningsMultiplied;
        const delay:number = this._winRatioConfig.duration > 0?  1: 0;

        tl.add(this._countUp.getEndAnimation(multipliedWin, this._winRatioConfig, 1, gameData.isMultipliedBigWin));

        if(gameData.isMultipliedBigWin) {
            tl.add(this.getLevelEndAnimation(this._winRatioConfig, delay), 0);
        }
        return tl;
    }

    private createCountUp(symbolDuration:number, gameData:DirtyWildsParsedGameData):TimelineLite {
        const afterStopMultiplier:number = gameData.afterStopMultiplier;
        const singleWin:number = gameData.singleWin;
        const multipliedWin:number = gameData.totalSpinWinningsMultiplied;

        const tl:TimelineLite = new TimelineLite();

        // tl.add(() => DirtyWildGameModuleConfig.soundPlayer.playNormalWinSound(this._winRatioConfig), 0);
        tl.add(this.getLevelCountAnimation(symbolDuration, 0, singleWin, multipliedWin, afterStopMultiplier, gameData.isMultipliedBigWin));
        return tl;
    }


    private createBigWin(symbolDuration:number, gameData:DirtyWildsParsedGameData) {
        let levelConfigs:IDirtyWildWinRatioConfig[] = DirtyWildsGameConfig.instance.WIN_RATIOS.bigWin.concat();

        const totalDuration = this._winRatioConfig.duration;

        //symbolDuration is roughly 2.1334 maximum, but can be shorter, it depends on number of symbols/lines in the symbol win pres.
        const tl:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < levelConfigs.length; i++) {
            const config:IDirtyWildWinRatioConfig = levelConfigs[i];
            let startTime:number = (config.ratio / gameData.currentMultipliedWinRatio) * totalDuration;
            if(config.position < totalDuration) {
                tl.add(this.getLevelAnimation(config), i === 0 ? 0.2 : config.position);
            }
        }
        tl.add(() => DirtyWildGameModuleConfig.soundPlayer.startBigWinLoop(), 0);
        return tl;

    }

    private getLevelCountAnimation(duration:number, from:number, targetBeforeMultiply:number, targetAfterMultiply:number, multiplier:number, isBigWin:boolean) {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this._countUp.getWinDisplayWithMultiplier(from, targetBeforeMultiply, targetAfterMultiply, duration, multiplier, 0.2, this._winRatioConfig, isBigWin, this._isPotrait), 0);
        return tl;
    }

    private getLevelAnimation(level:IDirtyWildWinRatioConfig) {
        const tl:TimelineLite = new TimelineLite();

        const startTween = new SpineTween(this._bigWinSpine, 1, "step"+ (level.winIndex) + "Start", 0);
        tl.add([
            startTween
        ], 0);
        tl.add(new SpineTween(this._bigWinSpine, 0, "coinsplash", 0), 0);
        tl.add(new SpineTween(this._bigWinSpine, 1, "step"+ (level.winIndex), -1), startTween.duration());

        // tl.delay(-this.getLevelClimaxStartTime());

        return tl;
    }

    private getLevelEndAnimation(level:IDirtyWildWinRatioConfig, delay:number) {
        const tl:TimelineLite = new TimelineLite();

        if(!this._bigWinSpine.state.getCurrent(1) || this._bigWinSpine.state.getCurrent(1).animation.name != "step"+ (level.winIndex)) {
            tl.add(new SpineTween(this._bigWinSpine, 1, "step"+ (level.winIndex)));
            // delay = Math.max(tl.duration() - this.getLevelClimaxStartTime(), delay);
        }


        tl.add([
            new SpineTween(this._bigWinSpine, 0, "coinsplash", 0),
            new SpineTween(this._bigWinSpine, 1, "step"+ (level.winIndex) + "end"),
            // () => this._bigWinEffects.endEffects()
        ], delay);

        return tl;

    }

    protected onResize(resizeData: IResizeData): void{
        super.onResize(resizeData);
        this._isPotrait = resizeData.orientation == Orientation.PORTRAIT;
    }

    //Use this to time the "climax" of the level _start.
    // Eg. the animation has a 0.3 sec fade in time,
    // by setting delay to -0.3, the animation is fully faded
    // in when it hits that levels ratio mark (15 x bet for example).
    private getLevelClimaxStartTime() {
        return 0.3;
    }
}